import axiosInstance from '../../http/axios-instance';

// Mesmo fallback do FullLayout (AbConfigSkin.getSkinCor()), pela instância axios
// do React em vez de um service Angular. Nunca propaga erro: o chamador só decide
// entre "tem cor" e "não tem", nunca lida com rejeição.
export async function fetchSkinCor(): Promise<string | null> {
  try {
    const response = await axiosInstance.get('public/config_skin/skinconta/');
    const cor = (response.data as { cor?: string } | undefined)?.cor;
    return cor?.length ? cor : null;
  } catch {
    return null;
  }
}
